import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PageKey =
  'Dashboard/Home' |
  'Dashboard/Cadastro/Cliente' |
  'Dashboard/Cadastro/Usuario' |
  'Dashboard/Cadastro/Vendedor' |
  'Dashboard/Cadastro/Perfil' |
  'Geo-Veles/' |
  'Geo-Veles/Projetos' |
  'Geo-Veles/Extracoes'

interface IUIState {
  activePage: PageKey
  loadings: {
    loading: boolean
    message?: string
    id: string
  }[]
}

const initialState: IUIState = {
  activePage: 'Geo-Veles/',
  loadings: []

};

const uiSlice = createSlice({
  name: 'UI',
  initialState,
  reducers: {
    setActivePageState(state, action: PayloadAction<{
      activePage: PageKey
    }>) {
      state.activePage = action.payload.activePage
    },
    setLoadingState(state, action: PayloadAction<{
      loading: boolean,
      id: string,
      message?: string
    }>) {
      if (action.payload.loading) {
        state.loadings.push({
          loading: action.payload.loading,
          id: action.payload.id,
          message: action.payload.message
        })
      } else {
        state.loadings = initialState.loadings
      }
    },
  },
});

export const {
  setActivePageState,
  setLoadingState
} = uiSlice.actions;


export const uiReducer = uiSlice.reducer;